import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/th'
import 'dayjs/locale/en'
import 'dayjs/locale/zh-cn'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(buddhistEra)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(updateLocale)

const dayjstimethai = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('th').format('LT')
}
const dayjsdatethai = (data) => {
  return dayjs(data).add(543, 'year').tz('Pacific/Kiritimati').locale('th').format('ll')
}
const dayjsdateen = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('en').format('ll')
}
const dayjsdatecn = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('zh-cn').format('ll')
}
const dayjstimethaiformnow = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
}
const dayjstimethaiformnowcn = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD HH:mm:ss').locale('zh-cn').fromNow()
}
const dayjstimethaiformnowen = (data) => {
  return dayjs(dayjs(data).add(7, 'hour').tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD HH:mm:ss').fromNow()
}
const dayjstimestamp = () => {
  return dayjs().tz('America/Danmarkshavn').format().replace(/T/g, ' ').replace('Z', '')
}
const dayjsdatetimethai = (data) => {
  return dayjs(data).tz('Asia/Bangkok').locale('th').format('llll').split('เวลา')[0]
}
const dayjsCreateDate = () => {
  return dayjs().tz('Asia/Bangkok').locale('th').format().replace(/T/g, ' ').replace('Z', '')
}

export default {
  dayjstimethai,
  dayjsdatethai,
  dayjstimethaiformnow,
  dayjstimethaiformnowcn,
  dayjstimethaiformnowen,
  dayjstimestamp,
  dayjsdatetimethai,
  dayjsdateen,
  dayjsdatecn,
  dayjsCreateDate
}
